import { createI18n } from 'vue-i18n'
import { nextTick } from 'vue'

// Import all language modules
const modules = import.meta.glob('./locales/**/*.js', { eager: true })

// Function to get nested translations
const getNestedTranslations = (modules, lang) => {
  return Object.entries(modules)
    .filter(([key]) => key.includes(`/${lang}/`))
    .reduce((acc, [key, value]) => {
      const moduleName = key.split('/').pop().replace('.js', '')
      acc[moduleName] = value.default
      return acc
    }, {})
}

// Create messages object with all languages
const messages = {
  en: getNestedTranslations(modules, 'en'),
  es: getNestedTranslations(modules, 'es'),
  pt: getNestedTranslations(modules, 'pt'),
}

// Helper to get initial locale
const getInitialLocale = () => {
  const savedLocale = localStorage.getItem('user-locale')
  if (savedLocale) return savedLocale

  const browserLocale = navigator.language.split('-')[0]
  return ['en', 'es', 'pt'].includes(browserLocale) ? browserLocale : 'en'
}

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
  globalInjection: true,
})

// Helper function to set locale
export async function setLocale(locale) {
  if (!i18n.global.availableLocales.includes(locale)) {
    console.warn(`Locale ${locale} not found, falling back to en`)
    locale = 'en'
  }

  if (i18n.global.locale.value === locale) {
    return
  }

  try {
    i18n.global.locale.value = locale
    document.querySelector('html').setAttribute('lang', locale)
    await nextTick()
  } catch (error) {
    console.error('Error changing locale:', error)
    throw error
  }
}

export default i18n
